module.exports = __webpack_public_path__ + "static/media/Paperplane.828ffa2e.svg";